import { render, staticRenderFns } from "./ProfileDelete.vue?vue&type=template&id=4e638bdc&scoped=true&"
import script from "./ProfileDelete.vue?vue&type=script&lang=js&"
export * from "./ProfileDelete.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDelete.vue?vue&type=style&index=0&id=4e638bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e638bdc",
  null
  
)

export default component.exports